/*
    模块组件
    ChenYN

    说明
    帖子

    版本
    1.0

    传参
        forumData Object : 必填 当前帖子的数据
        tagTop String : 非必填 当前帖子的tag
        isLikesFun Function : 非必填 点赞事件
        loadFun Function : 非必填 加载完成事件
        deleteForum Fcuntion : 非必填 删除主题
        replyType Boolean : 非必填 是否回复模式，这个时候点击删除是删除回复内容，不是主题
        deleteReply : 非必填 删除回复
        deleteComment : 非必填 删除评论事件
        isCollect Boolean: 非必填 是否收藏模式
        collectFun Function: 非必填 收藏事件
    依赖
    /style/2019/h5/css/common.css
    vue.js
    import ForumFoot from '@/components/Seven_ForumFoot/ForumFoot.vue';
    import ImageHandle from '@/components/Seven_ImageHandle/ImageHandle.vue';

    案例
    <forum></forum>
*/
<template>


    <div class="forum_wrap" @click.stop="jumpHandle">
        <forum-head :achievement="achievement" :date="forumData.publish_time||forumData.created_at" :delFun="delForum" :showDel="forumData.user.user_id == userInfo.user_id" :user="forumData.user" :topTag="tagTop || (forumData.sub_forum && forumData.sub_forum.name ? forumData.sub_forum.name : '')" :dateType="dateType"></forum-head>

        <!--问答模块-->
        <div class="forum_text" v-if="forumData.sub_forum&&forumData.sub_forum.name=='问答'&&replyType == false">
            <div class="forum_Icon">
                <span>问答</span>
            </div>
            <div class="forum_ask">
                <div class="forum_title">{{limited(getPlainText(forumData.subject))}}</div>
                <div class="forum_concent">
                    <div class="forum_txt van-multi-ellipsis--l3">{{getPlainText(forumData.content)}}</div>
                    <div class="forum_img" v-if='forumData.images&&forumData.images.length>0'>
                        <img  :src="forumData.images[0]" @click.stop="preview(forumData.images.slice(0,1))"/>
                    </div>
                </div>
                <!-- <div class="forum_content van-multi-ellipsis--l3">{{getPlainText(forumData.content)}}</div> -->
            </div>
        </div>
        <!--问答模块-->

        <!--回复模块-->
        <div class="forum_reply" v-else-if="replyType == true">
            <div class="forum_praise_txt">
                <div>回复</div>
                <div class="forum_praise_name van-ellipsis">{{forumData.origin.user.nickname}}</div>
                <div class="van-ellipsis">{{forumData.content}}</div>
            </div>
            <div>
                <div class="forum_concent" v-if="getPlainText(forumData.content)">
                    <div class="forum_wrap">
                        <div class="forum_wrap_content">
                            <div class="forum_username">@{{forumData.origin.user.nickname}}</div>
                            <div class="forum_main">
                                <div class="forum_txt van-multi-ellipsis--l3">{{getPlainText(forumData.origin.content)}}</div>
                                <img :src="forumData.origin.image[0]" v-if="forumData.origin.image[0]">
                                <!-- <image-handle :load="load" v-if="forumData.origin.image||forumData.origin.images" :images="forumData.origin.image||forumData.origin.images"></image-handle> -->
                                <div v-else class="forum_main_head">
                                    <img class="head" :src="forumData.origin.user.user_avatar" v-if="forumData.origin.user.user_avatar">
                                    <img class="head_dress" :src="forumData.origin.user.user_avatar_frame.avatar_frame" v-else-if="forumData.origin.user.user_avatar_frame">
                                    <img class="head" :src="platform == 'm9377' ? defaultAvatar : platform == 'mengw' ? defaultMengwAvatar : defaultChuangyueAvatar" v-else>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--回复模块-->

        <!--其它模块-->
        <div v-else>
            <div class="forum_title">{{limited(forumData.subject)}}</div>

            <div class="forum_content van-multi-ellipsis--l3" v-html="getPlainText(decodeHtml(forumData.content))"></div>
            <!-- <div class="forum_content van-multi-ellipsis--l3" v-html="getPlainText(forumData.content)"></div> -->

            <div class="image_wrapper">
                <image-handle :load="load" :images="forumData.image||forumData.images"></image-handle>
            </div>

            <div class="superTopic" v-if="forumData.super_topics">
                <div class="superTopic_item" v-for="(v,index) in forumData.super_topics" :key="index" @click.stop="goSuperTopic(v)"># {{ v.name }}</div>
            </div>
        </div>
        <!--其它模块-->

    </div>

    <div class="video_wrapper" v-if="forumData.video_url">
        <Video
            ref="videoCom"
            :videoData="{ video: forumData.video_url, cover: forumData.cover_url }"
            :videoConfig="{
                autoplay: false,
                muted: true,
                loop: true,
                controls: true
            }"
        />
    </div>

    <div class="foot_wrap">
        <forum-foot :commentFun="userComment" :likeFun="userLike" :views="forumData.views" :userLike="forumData.user_like" :posts="forumData.posts" :likes="forumData.likes" :isCollect="isCollect" :userCollect="forumData.favorite_id" :collectFun="collectFun"></forum-foot>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, computed,} from 'vue';
import { ImagePreview } from "vant"
import ForumHead from '@/components/Seven_ForumHead/ForumHead.vue';
import ForumFoot from '@/components/Seven_ForumFoot/ForumFoot.vue';
import ImageHandle from '@/components/Seven_ImageHandle/ImageHandle.vue';
import Video from "@/components/Video/Video.vue";
import Util from '@/assets/js/lib/util';
import router from '@/router';
import { useStore } from 'vuex';
import defaultAvatar from '@/assets/images/common/avatar_default.png'
import defaultMengwAvatar from '@/assets/images/common/avatar_default_mengw.png'
import defaultChuangyueAvatar from '@/assets/images/common/avatar_default_chuangyue.png'

export default defineComponent({
    name: 'Forum',
    components: { ForumHead, ImageHandle, ForumFoot, Video, ImagePreview },
    props: {
        forumData: {
            type: Object
        },
        tagTop: {
            type: String
        },
        isLikesFun: {
            type: Function
        },
        loadFun: {
            type: Function
        },
        deleteForum: {
            type: Function
        },
        clickStat: {
            type: Function
        },
        replyType: {
            type: Boolean,
            default: false,
        },
        dateType: {
            type: Number,
        },
        deleteComment: {
            type: Function
        },
        deleteReply: {
            type: Function
        },
        isCollect: {
            type: Boolean,
            default: false,
        },
        collectFun: {
            type: Function,
        },
        achievement: {
            type: Array,
            default: []
        }
    },
    setup(props) {
        const { forumData, achievement } = toRefs(props);
        const store = useStore();
        const state = reactive({
            util: new Util(),
            userInfo: computed(() => store.state.userInfo),
            defaultAvatar,
            defaultMengwAvatar,
            defaultChuangyueAvatar,
            platform: window.Config.platform,
            forumData,
            achievement
        });

        const methods = {
            preview : (images) => {
                ImagePreview({
                    images: images,
                    closeable: true,
                });
            },
            goState: (o) => router.push(o) ,
            userLike: async () => {
                if (!state.util.getCookieLocalStorage('access_token')) {
                    state.util.login({ query: { routerurl: router?.options?.history?.state?.current } }, 'replace')
                    return false;
                }
                if(props.isLikesFun){
                    if(props.forumData.type == 3){
                        props.isLikesFun({
                            comment_id: props.forumData.rid,
                            tid: props.forumData.tid,
                            type: 3,
                            status: props.forumData.user_like == 0 ? 1 : 0,
                        })
                    }else if(props.forumData.type == 2){
                        props.isLikesFun({
                            comment_id: props.forumData.pid,
                            tid: props.forumData.tid,
                            type: 2,
                            status: props.forumData.user_like == 0 ? 1 : 0,
                        })
                    }else{
                        props.isLikesFun({
                            tid: props.forumData.tid,
                            type: 1,
                            status: props.forumData.user_like == 0 ? 1 : 0,
                        })
                    }
                }
            },
            userComment: async () => {
                const res = await state.util.getJson('/thread/detail', 'GET', {tid: props.forumData.tid}, true);
                if(res.code != 0){
                    window.Components.toast(res.msg)
                    return
                }
                const query = {type: 'comment'}
                if(props.clickStat){
                    query.is_announce = '1'
                    props.clickStat({id: props.forumData.tid, is_announce: query.is_announce})
                }
                methods.goState({
                    name: 'forumdetail',
                    params: {id: props.forumData.tid},
                    query
                });
            },
            collectFun: () => {
                if(props.collectFun){
                    props.collectFun({
                        tid: props.forumData.tid,
                        status: props.forumData.favorite_id == 0 ? 1 : 0,
                    });
                }
            },
            load: () => {
                if(props.loadFun){
                    props.loadFun();
                }
            },
            delForum: () => {
                if(props.replyType){
                        if(props.forumData.type == 2){
                            if(props.deleteComment){
                                props.deleteComment({pid: props.forumData.pid})
                            }
                        }else if(props.forumData.type == 3){
                            if(props.deleteReply){
                                props.deleteReply({rid: props.forumData.rid})
                            }
                        }
                    }
                else{
                    if(props.deleteForum){
                        props.deleteForum({tid: props.forumData.tid})
                    }}
            },
            getPlainText: value => { //提取富文本文字内容
                value = state.util.encodeContent(value);
                value = value.replace(/<p>\s*<img\s+[^>]*\/?>\s*<\/p>\s*/g, "")
                value = value.replace(/<\/p><p>/g, "\n");
                value = value.replace(/(\t)/g, "");
                value = value.replace(/(\r)/g, "");
                value = value.replace(/<\/?[^>]*>/g, "");
                value = value.replace(/(\n)/g, "<br>");
                value = value.replace(/\s*/g, "");

                return value;
            },

            limited: (subject='')=>{
                return subject.length > 25?subject.slice(0,25) + '...': subject
            },
            jumpHandle: () => {
                const query = {}
                if(props.forumData.type == 2){
                    if(props.clickStat){
                        query.is_announce = '1'
                        props.clickStat({id: props.forumData.tid, is_announce: query.is_announce})
                    }
                    methods.goState({name:'forumdetail', params: {id: props.forumData.tid}, query});
                }else if(props.forumData.type == 3){
                    methods.goState({name: 'commentlist', params: {id: props.forumData.tid, pid: props.forumData.pid}});
                }else{
                    if(props.clickStat){
                        query.is_announce = '1'
                        props.clickStat({id: props.forumData.tid, is_announce: query.is_announce})
                    }
                    methods.goState({name:'forumdetail', params: {id: props.forumData.tid}, query});
                }
            },
            goSuperTopic: (item) => {
                methods.goState({name: 'superTopic', query: {id: item.id}})
            },
            // 使用 DOMParser 进行解码
            decodeHtml: (html) => {
                // 使用正则表达式全局匹配 &amp; 并替换为 &
                return html.replace(/&amp;/g, '&');
            }
        };
        onMounted(()=>{
        });

        return {
            ...toRefs(state),
            ...methods,
        };
    },
});
</script>
<style lang="less" scoped>
@import "./Forum.less";
</style>
